import Home from "../views/Home";
import Schedules from "../views/calendar/Schedules";
import Patients from "../views/patient/Patient";
import ChangePassword from "../views/auth/ChangePassword";
import Profile from "../views/Profile";
import Insurances from "../views/insurance/Insurances";
import RecordTypes from "../views/record_type/RecordTypes";
import Specialty from "../views/specialty/Specialty";
import Invite from "../views/invite/Invite";
import PaymentMethod from "../views/payment_method/PaymentMethod";
import Place from "../views/place/Place";
import Places from "../views/place/Index";
import ProfessionalAttendance from "../views/attendance/Index";
import Attendance from "../views/attendance/Attendance";
import PrescriptionProtocol from "../views/prescription_protocol/PrescriptionProtocol";
import ExamProtocol from "../views/exam_protocol/ExamProtocol";
import DocumentTemplates from "../views/document_template/DocumentTemplates";
import MedicalRecord from "../views/patient/medical_record/MedicalRecord";
import CardAdministrator from "../views/card_administrator/CardAdministrator";
import Users from "../views/user/Index";
import Professionals from "../views/professional/Index";
import ProfDocuments from "../views/professional/document/ProfDocument";
import ReleaseTimes from "../views/calendar/release_times/ReleaseTimes.vue";
import VisitValues from "../views/visit_value/VisitValues";
import Exams from "../views/exams/Exams";
import SupplierTransferValues from "../views/supplier_transfer_value/SupplierTransferValues.vue";
import TransferTables from "../views/transfer_table/TransferTables.vue";
import AccessType from "../views/access_type/AccessType";
import Holidays from "../views/holiday/Index";
import EmailVerify from "../views/EmailVerify";
import Terminal from "../views/terminal/Terminal.vue";
import ServiceQueue from "../views/service_queue/ServiceQueue.vue";
import ReleaseTerminal from "../views/terminal/ReleaseTerminal.vue";
import RegisterTerminal from "../views/terminal/RegisterTerminal.vue";
import Subscriber from "@/views/subscriber/Subscriber.vue";
import Plan from "@/views/plan/Plan.vue";
import PlanDashboard from "@/views/plan/Dashboard.vue";
import PlanReports from "@/views/plan/Reports.vue";
import PlanCompany from "@/views/plan/company/Company.vue";
import SurveyList from "@/views/survey/SurveyList.vue";
import BudgetList from "@/views/budget/BudgetList.vue";
import SurveyAnswer from "@/views/survey/SurveyAnswer.vue";
import BillsToPay from "@/views/finance/bills_to_pay/BillsToPay.vue";
import BillsToReceive from "@/views/finance/bills_to_receive/BillsToReceive.vue";
import CashFlow from "@/views/finance/cash_flow/CashFlow.vue";
import TissGuides from "@/views/tiss/TissGuides.vue";
import TissBatches from "@/views/tiss/TissBatches.vue";
import Nfse from "@/views/nfse/Nfse.vue";
import CostCenter from "@/views/finance/cost_center/CostCenter.vue";
import TransactionCategory from "@/views/finance/transaction_category/TransactionCategory.vue";
import BankAccount from "@/views/finance/bank_account/BankAccount.vue";
import Customer from "@/views/finance/customer/Customer.vue";
import Supplier from "@/views/finance/supplier/Supplier.vue";
import WhatsAppIndex from "@/views/whatsapp/Index.vue";
import WhatsAppTemplates from "@/views/whatsapp/Templates.vue";
import Contract from "@/views/contract/Contract.vue";
import ContractTemplate from "@/views/contract_template/ContractTemplate.vue";
import PreScheduleFormList from "@/views/pre_schedule/PreScheduleFormList.vue";
import PreScheduleFormAnswers from "@/views/pre_schedule/PreScheduleFormAnswers.vue";
import MedicalRecordSettings from "@/views/medical_record_settings/MedicalRecordSettings.vue";
import SncrCallback from "@/views/sncr/SncrCallback.vue";

const routes = [
    {
        path: '/dashboard',
        name: 'Home',
        component: Home,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Painel',
            breadcrumb: [
                {name: 'Home'},
            ]
        }
    },
    {
        path: '/schedules',
        name: 'Schedules',
        component: Schedules,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Agendamentos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Agenda'},
                {name: 'Gestão de agendamentos'},
            ]
        }
    },
   {
        path: '/release-times',
        name: 'ReleaseTimes',
        component: ReleaseTimes,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Liberar Horário',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Agenda'},
                {name: 'Liberar Horário'},
            ]
        }
    },
    {
        path: '/insurances',
        name: 'Insurances',
        component: Insurances,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Convênios',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Convênios'},
            ]
        }
    },
    {
        path: '/holidays',
        name: 'Holidays',
        component: Holidays,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Feriados',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Feriados'},
            ]
        }
    },
    {
        path: '/specialties',
        name: 'Specialty',
        component: Specialty,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Especialidades',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Especialidades'},
            ]
        }
    },
    {
        path: '/record-types',
        name: 'RecordTypes',
        component: RecordTypes,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Modelos de Prontuários',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Modelos'},
                {name: 'Modelos de Prontuários'},
            ]
        }
    },
    {
        path: '/payment-methods',
        name: 'PaymentMethod',
        component: PaymentMethod,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Formas de Recebimento',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Formas de Recebimento'},
            ]
        }
    },
    {
        path: '/visit-values',
        name: 'VisitValues',
        component: VisitValues,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Tabela de Valores',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Tabela de Valores'},
            ]
        }
    },
    {
        path: '/exams',
        name: 'Exams',
        component: Exams,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Exames/Procedimentos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Exames/Procedimentos'},
            ]
        }
    },
    {
        path: '/supplier-transfer-values',
        name: 'SupplierTransferValues',
        component: SupplierTransferValues,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Tabela de Valores (Convênios)',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Tabela de Valores (Convênios)'},
            ]
        }
    },
    {
        path: '/transfer-tables',
        name: 'TransferTables',
        component: TransferTables,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Tabelas de repasse',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Tabelas de repasse'},
            ]
        }
    },
    {
        path: '/invites',
        name: 'Invites',
        component: Invite,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Convites',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Convites'},
            ]
        }
    },
    {
        path: '/place',
        name: 'Place',
        component: Place,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Locais',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Locais'},
            ]
        }
    },
    {
        path: '/places',
        name: 'Places',
        component: Places,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Locais',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Locais'},
            ]
        }
    },
    {
        path: '/prescription-protocols',
        name: 'PrescriptionProtocol',
        component: PrescriptionProtocol,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Modelos de Prescrições',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Modelos'},
                {name: 'Modelos de Prescrições'},
            ]
        }
    },
    {
        path: '/exam-protocols',
        name: 'ExamProtocol',
        component: ExamProtocol,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Modelos de Exames',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Modelos'},
                {name: 'Modelos de Exames'},
            ]
        }
    },
    {
        path: '/document-templates',
        name: 'DocumentTemplates',
        component: DocumentTemplates,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Modelos de Documentos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Modelos'},
                {name: 'Modelos de Documentos'},
            ]
        }
    },
    {
        path: '/attendances',
        name: 'ProfessionalAttendance',
        component: ProfessionalAttendance,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Atendimento',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Pacientes Aguardando Atendimento'},
            ]
        }
    },
    {
        path: '/attendances/:scheduleId',
        name: 'Attendance',
        component: Attendance,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Atendimento',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Atendimento'},
            ]
        }
    },
    {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Alterar Senha',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Alterar Senha'},
            ]
        }
    },
    {
        path: '/sncr/callback',
        name: 'SncrCallback',
        component: SncrCallback,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Autenticação gov.br',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Autenticação gov.br'},
            ]
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Perfil',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Perfil'},
            ]
        }
    },
    {
        path: '/patients',
        name: 'Patients',
        component: Patients,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Pacientes',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Pacientes'},
            ]
        }
    },
    {
        path: '/patients/:patientId',
        name: 'MedicalRecord',
        component: MedicalRecord,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Prontuário',
            breadcrumb: [
                {name: 'Home', link: '/dashboard'},
                {name: 'Pacientes', link: '/patients'},
                {name: 'Prontuário'},
            ]
        }
    },
    {
        path: '/card-administrator',
        name: 'CardAdministrator',
        component: CardAdministrator,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Administradora de cartão',
            breadcrumb: [
                {name: 'Home', link: '/dashboard'},
                {name: 'Administradora de cartão', link: '/card-administrators'},
                {name: 'Administradora'},
            ]
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Usuário',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Usuários'},
            ]
        }
    },
    {
        path: '/professionals',
        name: 'Professionals',
        component: Professionals,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Profissionais',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Profissionais'},
            ]
        }
    },
    {
        path: '/documents',
        name: 'ProfDocuments',
        component: ProfDocuments,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Documentos do profissional',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Documentos do profissional'},
            ]
        }
    },
    {
        path: '/access-types',
        name: 'AccesType',
        component: AccessType,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Regras de Acesso',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Regras de Acesso'},
            ]
        }
    },
    {
        path: '/email/verify',
        name: 'EmailVerify',
        component: EmailVerify,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Verificar e-mail',
        }
    },
    {
        path: '/service-queues',
        name: 'ServiceQueue',
        component: ServiceQueue,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Filas de Atendimento',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Filas de Atendimento'},
            ]
        }
    },
    {
        path: '/terminals',
        name: 'Totens, Telas e guichês',
        component: Terminal,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Totens, Telas e guichês',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Totens, Telas e guichês'},
            ]
        }
    },
    {
        path: '/register-terminal',
        name: 'RegisterTerminal',
        component: RegisterTerminal,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Registrar Terminal',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Cadastros'},
                {name: 'Registrar Terminal'},
            ]
        }
    },
    {
        path: '/subscribers',
        name: 'Subscribers',
        component: Subscriber,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Assinantes',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Assinantes'},
            ]
        }
    },
    {
        path: '/plans',
        name: 'Plan',
        component: Plan,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Planos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos'},
            ]
        }
    },
    {
        path: '/plans/dashboard',
        name: 'PlanDashboard',
        component: PlanDashboard,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Dashboard de Planos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos', link: 'Plan'},
                {name: 'Dashboard'},
            ]
        }
    },
    {
        path: '/plans/reports',
        name: 'PlanReports',
        component: PlanReports,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Relatórios de Planos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos', link: 'Plan'},
                {name: 'Relatórios'},
            ]
        }
    },
    {
        path: '/plans/companies',
        name: 'PlanCompany',
        component: PlanCompany,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Empresas Conveniadas',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos', link: 'Plan'},
                {name: 'Empresas Conveniadas'},
            ]
        }
    },
    {
        path: '/surveys',
        name: 'Survey',
        component: SurveyList,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Pesquisas',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Pesquisas'},
            ]
        }
    },
    {
        path: '/surveys/:surveyId',
        name: 'SurveyAnswer',
        component: SurveyAnswer,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Pesquisas',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Gerenciar Respostas da Pesquisa'},
            ]
        }
    },
    {
        path: '/pre-schedule-forms',
        name: 'PreScheduleForms',
        component: PreScheduleFormList,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Formulários de Pré-Agendamento',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Formulários de Pré-Agendamento'},
            ]
        }
    },
    {
        path: '/medical-record-settings',
        name: 'MedicalRecordSettings',
        component: MedicalRecordSettings,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Configurações',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Prontuário'},
                {name: 'Configurações'},
            ]
        }
    },
    {
        path: '/medical-record-share-settings',
        redirect: { name: 'MedicalRecordSettings' },
    },
    {
        path: '/pre-schedule-forms/:formId/answers',
        name: 'PreScheduleFormAnswers',
        component: PreScheduleFormAnswers,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Respostas do Formulário',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Formulários de Pré-Agendamento', link: 'PreScheduleForms'},
                {name: 'Respostas'},
            ]
        }
    },
    {
        path: '/budgets',
        name: 'Budgets',
        component: BudgetList,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Vendas',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Vendas de exames, procedimentos e serviços'},
            ]
        }
    },
    {
        path: '/release-terminal',
        name: 'ReleaseTerminal',
        component: ReleaseTerminal,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Liberar Terminal Externo',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Liberar Terminal Externo'},
            ]
        }
    },
    {
        path: '/whatsapp',
        name: 'WhatsApp',
        component: WhatsAppIndex,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'WhatsApp',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'WhatsApp'},
            ]
        }
    },
    {
        path: '/whatsapp/templates',
        name: 'WhatsAppTemplates',
        component: WhatsAppTemplates,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Templates de Mensagens',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'WhatsApp', link: 'whatsapp'},
                {name: 'Templates'},
            ]
        }
    },
    {
        path: '/finance/bills-to-pay',
        name: 'BillsToPay',
        component: BillsToPay,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Contas a pagar',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Contas a pagar'},
            ]
        }
    },
    {
        path: '/finance/bills-to-receive',
        name: 'BillsToReceive',
        component: BillsToReceive,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Contas a receber',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Contas a receber'},
            ]
        }
    },
    {
        path: '/finance/cash-flow',
        name: 'CashFlow',
        component: CashFlow,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Fluxo de caixa',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Fluxo de caixa'},
            ]
        }
    },
    {
        path: '/finance/cost-centers',
        name: 'CostCenter',
        component: CostCenter,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Centro de Custos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Centro de Custos'},
            ]
        }
    },
    {
        path: '/finance/customers',
        name: 'Customer',
        component: Customer,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Clientes',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Clientes'},
            ]
        }
    },
    {
        path: '/finance/suppliers',
        name: 'Supplier',
        component: Supplier,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Fornecedores',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Fornecedores'},
            ]
        }
    },
    {
        path: '/finance/transaction-categories',
        name: 'TransactionCategory',
        component: TransactionCategory,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Categorias de Transação',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Categorias de Transação'},
            ]
        }
    },
    {
        path: '/finance/bank-accounts',
        name: 'BankAccount',
        component: BankAccount,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Contas Bancárias',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Financeiro'},
                {name: 'Contas Bancárias'},
            ]
        }
    },
    {
        path: '/plans/contracts',
        name: 'Contract',
        component: Contract,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Contratos',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos', link: 'Plan'},
                {name: 'Contratos'},
            ]
        }
    },
    {
        path: '/plans/contract-templates',
        name: 'ContractTemplate',
        component: ContractTemplate,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Modelos de Contrato',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Planos', link: 'Plan'},
                {name: 'Contratos', link: 'Contract'},
                {name: 'Modelos'},
            ]
        }
    },
    {
        path: '/tiss/guides',
        name: 'TissGuides',
        component: TissGuides,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Guias',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Guias'},
            ]
        }
    },
    {
        path: '/tiss/batches',
        name: 'TissBatches',
        component: TissBatches,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Lotes',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Lotes'},
            ]
        }
    },
    {
        path: '/nfse',
        name: 'Nfse',
        component: Nfse,
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Notas Fiscais de Serviço',
            breadcrumb: [
                {name: 'Home', link: 'dashboard'},
                {name: 'Notas Fiscais'},
            ]
        }
    },
    {
        path: '/subscription',
        name: 'SubscriptionOverview',
        component: () => import('../views/platform_subscription/SubscriptionOverview.vue'),
        meta: {
            auth: true,
            layout: 'professional-layout',
            title: 'Minha assinatura',
            breadcrumb: [{ name: 'Home', link: 'dashboard' }, { name: 'Assinatura' }],
        },
    },
    {
        path: '/subscription/plans',
        name: 'SubscriptionPlans',
        component: () => import('../views/platform_subscription/SubscriptionPlans.vue'),
        meta: { auth: true, layout: 'professional-layout', title: 'Planos Ubbi' },
    },
    {
        path: '/subscription/invoices',
        name: 'SubscriptionInvoices',
        component: () => import('../views/platform_subscription/SubscriptionInvoices.vue'),
        meta: { auth: true, layout: 'professional-layout', title: 'Faturas' },
    },
    {
        path: '/subscription/statement',
        name: 'SubscriptionStatement',
        component: () => import('../views/platform_subscription/SubscriptionStatement.vue'),
        meta: { auth: true, layout: 'professional-layout', title: 'Extrato' },
    },
    {
        path: '/subscription/payment-method',
        name: 'SubscriptionPaymentMethod',
        component: () => import('../views/platform_subscription/SubscriptionPaymentMethod.vue'),
        meta: { auth: true, layout: 'professional-layout', title: 'Forma de pagamento' },
    },
    {
        path: '/subscription/overdue',
        name: 'SubscriptionOverdue',
        component: () => import('../views/platform_subscription/SubscriptionOverdue.vue'),
        meta: { auth: true, layout: 'professional-layout', title: 'Assinatura em atraso' },
    },
    {
        path: '/subscription/ativar-gestao',
        name: 'ActivateManagementSubscription',
        component: () => import('../views/platform_subscription/ActivateManagementSubscription.vue'),
        meta: {
            auth: true,
            layout: 'subscription-onboarding-layout',
            title: 'Ativar sistema de gestão',
        },
    },
];

export default routes
